import { useAccounts } from '@api/hooks';
import { Chip, Loader, Typography } from '@gurupay/gp-ui-library';
import { ProfileStatusChip } from '@pages/dashboard/components/StatusWidget/ProfileStatusChip.tsx';
import { useTranslation } from 'react-i18next';
import { AccountStatus } from 'types/operations.ts';

export const StatusGrid = () => {
	const { t } = useTranslation('', { keyPrefix: 'statusWidget' });
	const { data, isLoading } = useAccounts({ limit: 1, status: [AccountStatus.BLOCKED] });

	return (
		<div className="flex flex-col gap-space-16">
			<div className="flex w-full items-center justify-between">
				<Typography className="font-medium text-neutral-800" level="small-text">
					{t('twoFa.label')}
				</Typography>
				<Chip color="success" label={t('status.active')} size="small" variant="filled" />
			</div>
			<div className="flex w-full items-center justify-between">
				<Typography className="font-medium text-neutral-800" level="small-text">
					{t('odd.label')}
				</Typography>
				<ProfileStatusChip />
			</div>
			<div className="flex w-full items-center justify-between">
				<Typography className="font-medium text-neutral-800" level="small-text">
					{t('blockedAccounts.label')}
				</Typography>
				{isLoading ? (
					<Loader className="!w-space-16 !h-space-16" />
				) : (
					<Chip
						color={data?.pagination?.count ? 'error' : 'success'}
						label={
							data?.pagination?.count
								? data?.pagination?.count.toString()
								: t('blockedAccounts.none')
						}
						size="small"
						variant="filled"
					/>
				)}
			</div>
		</div>
	);
};
